import { PrimitiveAtom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { Item } from '@/types';
import { surveyAtom } from './surveyAtom';

export const itemsAtom = focusAtom(
  surveyAtom,
  (optic) => optic.optional().prop('items') || []
) as PrimitiveAtom<Array<Item>>;
